/**
 * Adds a checkbox that checks/unchecks a load of other checkboxes
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/manipulation/insert/insert.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/traversal/filter/filter.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/traversal/filter/filter.js";

const select = (obj, check, id) => {

 	// select all / none
	if (obj.length) {
	 	obj.prepend(
 			$("<input/>", {
 				type: "checkbox",
 				value: "",
 				"class": obj.attr("class")+"-switch",
 				id: id
 			})
 				.prop("checked", check.is(":not(:checked)") ? "" : "checked")
 				.on("change", function () {check.prop("checked", this.checked);})
 		);
	}
	return obj;
 },
 isSelected = (obj, name) => {
 	if (obj.length) {
	 	const pos = name.indexOf("["),
	 		select = pos > -1 ? name.substr(0, pos) + "[select][]" : "select[]";
	 	return $("input[name='" + select + "']", obj).is(":checked");
	}
	return false;
};

export {select, isSelected};
